var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"facebook"),React.createElement("path",{"d":"M60.71,50h-7V75H43.32V50H38.38V41.19h4.94V35.48C43.32,31.39,45.26,25,53.8,25l7.69,0V33.6H55.91A2.11,2.11,0,0,0,53.7,36v5.19h7.92Z","key":1})]);
}

IconFacebook.displayName = "IconFacebook";

IconFacebook.defaultProps = {"id":"Ebene_1","data-name":"Ebene 1","viewBox":"0 0 100 100"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
